export default __webpack_public_path__ + "static/media/Shaka_particle_final_08.0076b041.png";